import { CustomerPaymentData } from '../types';

export const cardExpired = (params: {
  expirationDate: CustomerPaymentData['expirationDate'];
}): boolean => {
  if (params.expirationDate) {
    let expirationDate = params.expirationDate;
    if (params.expirationDate.includes('/')) {
      // Convert "01/2018" to "2018-01"
      const parts = params.expirationDate.split('/');
      expirationDate = `${parts[1]}-${parts[0]}`;
    }

    const date = new Date();
    const year = date.getFullYear();
    // getMonth is 0 based
    const month = date.getMonth() + 1;
    let monthFormatted = month.toString();
    if (month < 10) {
      // Add a 0 to the beginning of the value to match Authorize
      // So result is "06" instead of "6"
      monthFormatted = `0${month}`;
    }
    const current = year.toString() + '-' + monthFormatted;

    return Boolean(expirationDate < current);
  } else {
    return false;
  }
};
